import { useQuery } from '@tanstack/react-query';
import { Users, Loader2 } from 'lucide-react';
import { siteUser } from '@/api/client';
import { PageHeader } from '@/components/layout/PageHeader';

/**
 * F5 - /staff-documentation
 *
 * Read-only whitelist for the `site_user` role. Lists DoA
 * responsibilities whose catalog row has visible_to_site_users='true'.
 * The full DoA grid is denied to site_user by the permission matrix.
 */
export function StaffDocumentationPage() {
  const q = useQuery({
    queryKey: ['site-user', 'staff-documentation'],
    queryFn: () => siteUser.staffDocumentation(),
    staleTime: 60_000,
  });

  return (
    <div className="space-y-6">
      <PageHeader
        title="Staff documentation"
        subtitle="Delegated responsibilities your Site Admin has published to all site staff. Contact your Site Admin if you need something that isn't listed."
      />
      <div className="mx-auto max-w-4xl">

      {q.isLoading && (
        <div className="flex items-center gap-2 text-text-3 py-8 justify-center">
          <Loader2 className="animate-spin" size={16} /> Loading…
        </div>
      )}

      {q.data && q.data.count === 0 && (
        <div className="rounded-sm border border-border-strong border-dashed p-6 text-center text-text-3 text-[13px]">
          Your Site Admin has not published any responsibilities to site users yet.
        </div>
      )}

      {q.data && q.data.count > 0 && (
        <div className="space-y-2">
          {q.data.responsibilities.map((r) => (
            <div key={r.code} className="flex items-start gap-3 bg-white border border-border-soft rounded-md shadow-card p-4">
              <Users size={18} className="text-navy mt-1 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-[13.5px] text-text-1">{r.label}</div>
                <div className="text-[12px] text-text-3 mt-0.5">{r.definition}</div>
                <div className="text-[11px] text-text-4 mt-1 font-mono">{r.code}</div>
              </div>
            </div>
          ))}
        </div>
      )}
      </div>
    </div>
  );
}
